import callApi, { CallApiResult, getCustomerId } from 'src/api';
import { SCHEMA_FEEDBACK_SHAPE } from 'src/schemas/MyData';

/* Customer Feedback */

export const fetchCustomerFeedback = (): Promise<CallApiResult> => {
    const endpoint = '/api/customerFeedback/current';
    return callApi(endpoint);
};

export const submitCustomerFeedback = (data: SCHEMA_FEEDBACK_SHAPE): Promise<CallApiResult> => {
    return callApi('/api/customerFeedback/current', { method: 'POST', data });
};

/* Portal Feedback (Stammdaten tab) */

export interface PortalFeedbackRequest {
    rating: number;
    taste: boolean;
    sleep: boolean;
    heartburn: boolean;
    farmers: boolean;
    bloodPressure: boolean;
    tolerance: boolean;
    energy: boolean;
    customFeedback?: string;
    allowPublishing?: boolean;
}

/** Once-only per customer; 409 = feedback already exists (legacy feedback counts, PM #54). */
export const submitPortalFeedback = (data: PortalFeedbackRequest): Promise<CallApiResult> => {
    const customerId = getCustomerId();
    return callApi(`/api/customer/${customerId}/feedback`, { method: 'POST', data });
};
